import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import * as L from 'leaflet';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-route-map',
  templateUrl: './route-map.component.html',
  styleUrls: ['./route-map.component.css']
})
export class RouteMapComponent implements OnInit {

  private map!: L.Map;
  private centroid: L.LatLngExpression = [42.3601, -71.0589];
  RouteData: any = [];
  search = ""
  latitude: any = "";
  longitude: any = "";
  LatLng: any = [];
  lat: any = "";
  lng: any = "";
  routeid: any = "";
  Data: any = [];
  singleRoute: any = [];

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService,private router: Router) { }

  ngOnInit(): void {
    // this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.initMap();
    // this.getRouteById(this.routeid)
  }




  private initMap(): void {

    console.log("initMap")
    let centroid1: L.LatLngExpression[]= [];

    this.generic_service.getAllRoute().subscribe(
      (res:any)=> {
        console.log(res)
        this.RouteData = res.response
        console.log(this.RouteData)

        if(res.response.length != 0) {
          let id = res.response[0].routeId;
          console.log(id)
          if(localStorage.getItem('rloc') != '' && localStorage.getItem('rloc') != null && localStorage.getItem('rloc') != undefined){
            id = Number(localStorage.getItem('rloc'))
            // zoom = 20
          }
          console.log(id)

          this.generic_service.getRouteById(id).subscribe(
            (response:any)=> {
              console.log(response)
              console.log(response.response.routeDetailResponses)
  
              for(let i=0; i<response.response.routeDetailResponses.length; i++){
                let obj:L.LatLngExpression = [
                  Number(response.response.routeDetailResponses[i].currentLatitude),
                  response.response.routeDetailResponses[i].currentLongitude
                ]
                centroid1.push(obj)
              }
  
              console.log(centroid1)
              let lat = centroid1[0]
              let lang = centroid1[0]
              let loc = 0;
              let zoom = 16
            
  
              this.map = L.map('map', {
                center: centroid1[0],
                zoom: zoom
              });
          
              const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 18,
                minZoom: 2,
                attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
              });
          
              // create 5 random jitteries and add them to map
              for(let i = 0; i < centroid1.length; i++){
                if(i == 0){
                  let loc = L.marker(centroid1[i] as L.LatLngExpression,{icon: this.defaultIcon}).bindPopup('a marker location').openPopup()
                  loc.addTo(this.map)
                }else if(i == centroid1.length-1){
                  let loc = L.marker(centroid1[i] as L.LatLngExpression,{icon: this.defaultIcon2}).bindPopup('a marker location').openPopup()
                  loc.addTo(this.map)
                }else{
                  let loc = L.marker(centroid1[i] as L.LatLngExpression,{icon: this.defaultIcon1}).bindPopup('a marker location').openPopup()
                  loc.addTo(this.map)
                }
  
              }
          
              
              tiles.addTo(this.map);
            },
            (err:any)=>{
              console.log(err)
            }
          )
        }else{
          this.map = L.map('map', {
            center: [17.3850, 78.4867],
            zoom: 16
          });
      
          const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 18,
            minZoom: 2,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          });  
          tiles.addTo(this.map);
        }



      },
      (err:any)=>{
        console.log(err)
      }
    )
    


    // console.log(this.map);


  }

  defaultIcon = L.icon({
    iconUrl: 'assets/loc2.png', // your path may vary ...
    iconSize: [40, 25],
    iconAnchor: [2, 2],
    popupAnchor: [0, -2]
  });

  defaultIcon1 = L.icon({
    iconUrl: 'assets/img/red1.png', // your path may vary ...
    iconSize: [5, 5],
    iconAnchor: [2, 2],
    popupAnchor: [0, -2]
  });

  defaultIcon2 = L.icon({
    iconUrl: 'assets/img/loc.png', // your path may vary ...
    iconSize: [18, 18],
    iconAnchor: [2, 2],
    popupAnchor: [0, -2]
  });

  getAllRoute(){
    this.generic_service.getAllRoute().subscribe(
      (res:any)=> {
        // console.log(res)
        this.RouteData = res.response
        console.log(this.RouteData)
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  ngOnDestroy(){
    console.log("ngOnDestroy")
    this.map.remove();

  }

  onChoseLocation(){
    localStorage.removeItem('rloc')
    location.reload();
  }

  singleLocation(index:any){
    localStorage.setItem('rloc', index)
    location.reload();
  }
}